import request from "../../request.js"
import qs from "qs";

// 新增用户
export  function addAiUser(data) {
	return request({
		url: "/ai-user/addAiUser",
		method: "POST",
		data
	})
}
// 获取用户列表
export  function getAiUserList(data) {
	return request({
		url: "/ai-user/getAiUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑用户
export  function updateAiUser(data) {
	return request({
		url: "/ai-user/updateAiUser",
		method: "POST",
		data
	})
}
// 登录
export  function webUserLogin(data) {
	return request({
		url: "/ai-web/webUserLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除用户
export  function deleteAiUser(data) {
	return request({
		url: "/ai-user/deleteAiUser",
		method: "POST",
		data
	})
}
// 新增部门
export  function addDepartment(data) {
	return request({
		url: "/ai-department/addDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除部门
export  function deleteDepartment(data) {
	return request({
		url: "/ai-department/deleteDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 查询部门
export  function getDepartmentList(data) {
	return request({
		url: "/ai-department/getDepartmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑部门
export  function updateDepartment(data) {
	return request({
		url: "/ai-department/updateDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增智能体
export  function addAiApp(data) {
	return request({
		url: "/ai-app/addAiApp",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除智能体
export  function deleteAiApp(data) {
	return request({
		url: "/ai-app/deleteAiApp",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取智能体
export  function getAiAppList(data) {
	return request({
		url: "/ai-app/getAiAppListAdmin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑智能体
export  function updateAiApp(data) {
	return request({
		url: "/ai-app/updateAiApp",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取智能体用户权限
export  function getAiAuthModelListUser(data) {
	return request({
		url: "/ai-auth-model/getAiAuthModelListUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增智能体用户权限
export  function addAiAuthModelListUser(data) {
	return request({
		url: "/ai-auth-model/addAiAuthModelListUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取智能体部门权限
export  function getAiAuthModelListDepartment(data) {
	return request({
		url: "/ai-auth-model/getAiAuthModelListDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增智能体部门权限
export  function addAiAuthModelListDepartment(data) {
	return request({
		url: "/ai-auth-model/addAiAuthModelListDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除智能体用户部门权限
export  function deleteAiAuthModel(data) {
	return request({
		url: "/ai-auth-model/deleteAiAuthModel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增知识库分类
export  function addAiKnowledgeClass(data) {
	return request({
		url: "/ai-knowledge-class/addAiKnowledgeClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除知识库分类
export  function deleteAiKnowledgeClass(data) {
	return request({
		url: "/ai-knowledge-class/deleteAiKnowledgeClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取知识库分类
export  function getAiKnowledgeClassList(data) {
	return request({
		url: "/ai-knowledge-class/getAiKnowledgeClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑知识库分类
export  function updateAiKnowledgeClass(data) {
	return request({
		url: "/ai-knowledge-class/updateAiKnowledgeClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增知识库
export  function addAiKnowledgeWare(data) {
	return request({
		url: "/ai-knowledge-ware/addAiKnowledgeWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑知识库
export  function updateAiKnowledgeWare(data) {
	return request({
		url: "/ai-knowledge-ware/updateAiKnowledgeWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除知识库
export  function deleteAiKnowledgeWare(data) {
	return request({
		url: "/ai-knowledge-ware/deleteAiKnowledgeWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取知识库列表
export  function getAiKnowledgeWareList(data) {
	return request({
		url: "/ai-knowledge-ware/getAiKnowledgeWareList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取知识库文件列表
export  function getAiKnowledgeFileList(data) {
	return request({
		url: "/ai-knowledge-file/getAiKnowledgeFileList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增知识库文件列表
export  function addAiKnowledgeFile(data) {
	return request({
		url: "/ai-knowledge-file/addAiKnowledgeFile",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑知识库文件
export  function updateAiKnowledgeFile(data) {
	return request({
		url: "/ai-knowledge-file/updateAiKnowledgeFile",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除知识库文件
export  function deleteAiKnowledgeFile(data) {
	return request({
		url: "/ai-knowledge-file/deleteAiKnowledgeFile",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取智能体与知识库关联列表
export  function getAiAppKnowledgeList(data) {
	return request({
		url: "/ai-app-knowledge/getAiAppKnowledgeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增智能体与知识库关联列表
export  function addAiAppKnowledge(data) {
	return request({
		url: "/ai-app-knowledge/addAiAppKnowledge",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除智能体与知识库关联列表
export  function deleteAiAppKnowledge(data) {
	return request({
		url: "/ai-app-knowledge/deleteAiAppKnowledge",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 上传到腾讯云
export  function uploadFileToTxCloudEquityAjTools(data) {
	return request({
		url: "/tx-cloud-file/uploadFileToTxCloudEquityAjTools",
		method: "POST",
		data
	})
}
//腾讯云秘钥
export  function getPolicyTxCloudEquityAjTools(data) {
	return request({
		url: "/tx-cloud-file/getPolicyTxCloudEquityAjTools",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体类型-新增
export  function addAiAppType(data) {
	return request({
		url: "/ai-app-type/addAiAppType",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体类型-编辑
export  function updateAiAppType(data) {
	return request({
		url: "/ai-app-type/updateAiAppType",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体类型-删除
export  function deleteAiAppType(data) {
	return request({
		url: "/ai-app-type/deleteAiAppType",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体类型-列表
export  function getAiAppTypeList(data) {
	return request({
		url: "/ai-app-type/getAiAppTypeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体会话记录-列表
export  function getAiUserChatListAdmin(data) {
	return request({
		url: "/ai-user-chat/getAiUserChatListAdmin",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体会话记录-详情
export  function getAiUserChatDetails(data) {
	return request({
		url: "/ai-user-chat/getAiUserChatDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//智能体会话记录-下载word
export  function exportAiUserChatMsgWord(data) {
	return request({
		url: "/ai-user-chat-msg/exportAiUserChatMsgWord",
		method: "POST",
		data:qs.stringify(data)
	})
}